import { useEffect, useState } from "react";

interface PaginationData<T> {
  data: T[];
  next: () => void;
  prev: () => void;
  currentPage: number;
  totalPages: number;
}

function usePagination<T>(
  key: string,
  totalItems: T[],
  initialPage = 1,
  itemsPerPage: number | null = 10
): PaginationData<T> {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const totalPages = itemsPerPage
    ? Math.ceil(totalItems.length / itemsPerPage)
    : 1;

  useEffect(() => {
    setCurrentPage(initialPage);
  }, [key]);

  const next = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const prev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const data =
    itemsPerPage !== null
      ? totalItems.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : totalItems;

  return { data, next, prev, currentPage, totalPages };
}

export default usePagination;
